module.exports = __webpack_public_path__ + "static/media/complete.5fc44128.svg";